export default __webpack_public_path__ + "c917b4b4a30352007b472b0974cc3058.png";